// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"5643786c","507":"34bcc649"}[chunkId] + ".chunk.css";
};